export default "__VITE_ASSET__HjND1XXn__"